import React, { useEffect } from "react";
import Breadcrumb from "../components/Breadcrumb/Breadcrumb";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header";
import PackagesLayout from "../layouts/PackagesLayout";
import TestimonialSlider from "../components/TestimonialSlider/TestimonialSlider";
import usePageMeta from "../Helpers/usePageMeta";

const Packages = () => {
  usePageMeta({
    title: "Packages | TZ Creation",
    description:
      "Web design, development, SEO and branding packages from TZ Creation, with transparent pricing.",
    path: "/packages",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div style={{ color: "#000000" }}>
      <Header />
      <Breadcrumb parentpageName="Home" currentPageName="Packages" />
      <PackagesLayout carousel={false} />

      <TestimonialSlider />
      <Footer />
    </div>
  );
};

export default Packages;
